import React from 'react';
import Icon from '@/v2/components/atoms/Icon';

import './Music.scss';

const Music = (props) => (
    <Icon iconName="Music" {...props}>
        <svg viewBox="0 0 43 43" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-663.000000, -850.000000)" stroke="#FFFFFF" strokeWidth="1.5">
                    <g transform="translate(663.000000, 850.000000)">
                        <path
                            // eslint-disable-next-line
                            d="M41.8839,21.3173 C41.8839,32.6753 32.6759,41.8833 21.3169,41.8833 C9.9579,41.8833 0.7499,32.6753 0.7499,21.3173 C0.7499,9.9583 9.9579,0.7503 21.3169,0.7503 C32.6759,0.7503 41.8839,9.9583 41.8839,21.3173 Z"
                            fillOpacity="0.4"
                            fill="#020A0D"
                        />
                        <path
                            // eslint-disable-next-line
                            d="M15.8512,26.786 L15.8512,16.462 C15.8512,15.216 16.8622,14.205 18.1082,14.205 L26.1922,14.205 C27.4382,14.205 28.4492,15.216 28.4492,16.462 L28.4492,26.786"
                            strokeLinecap="round"
                        />
                        <path
                            // eslint-disable-next-line
                            d="M15.8512,26.786 C15.8512,28.066 14.8142,29.103 13.5342,29.103 C12.2542,29.103 11.2172,28.066 11.2172,26.786 C11.2172,25.507 12.2542,24.469 13.5342,24.469 C14.8142,24.469 15.8512,25.507 15.8512,26.786 Z"
                            strokeLinecap="round"
                        />
                        <path
                            // eslint-disable-next-line
                            d="M28.4488,26.786 C28.4488,28.066 27.4108,29.103 26.1318,29.103 C24.8518,29.103 23.8138,28.066 23.8138,26.786 C23.8138,25.507 24.8518,24.469 26.1318,24.469 C27.4108,24.469 28.4488,25.507 28.4488,26.786 Z"
                            strokeLinecap="round"
                        />
                    </g>
                </g>
            </g>
        </svg>
    </Icon>
);

export default Music;
